var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"text-center mb-5"},[_vm._v("合計: "+_vm._s(_vm.value)+" 円 (税抜)")])])}
var staticRenderFns = []

export { render, staticRenderFns }